import { Component, EventEmitter, input, Input, OnInit, output, Output } from '@angular/core';
import { EComponentSize, EIcon, ELabelType, IButtonType } from '../../types';
import { Types } from 'shared-lib';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { LabelComponent } from '../label/label.component';
import { helper } from '../../../public-api';

@Component({
  selector: 'ui-profile-card',
  standalone: true,
  imports: [CommonModule, ButtonComponent, LabelComponent],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  imageUrl = input<string>();
  clickable = input<boolean>(false);
  title = input<string>('Título do Card');
  subtitle = input<string>('Subtítulo do Card');
  additionalInfo = input<string>();
  buttons = input<
  IButtonType[]
  >();

  action = output<string>();
  clicked = output<void>();

  ELabelType = ELabelType;
  EAlert = Types.EAlert;
  isHovered = false;
  darkMode = false;

  ngOnInit(): void {
    this.darkMode = helper.Functions.isDarkMode();
  }

  get imageClass(): string {
    return this.imageUrl() ? 'h-48 w-full object-cover rounded-t-lg' : 'hidden';
  }

  sendAction(event: Event,name: string){
    event.stopPropagation();
    this.action.emit(name);
  }

  handleClick(){
    this.clicked.emit();
  }
}
